export default __webpack_public_path__ + "static/media/phone-download.6b26e6bb.svg";